import React, { ReactNode, createContext, Dispatch, SetStateAction } from "react";
import useAuth, { FormPassword, Office, UserProps, UserToken } from "./hooks/useAuth";

interface AuthContextProviderProps {
  children: ReactNode;
}

type UserTypeCheck = 1 | 2 | 3;

const initialState: AuthContextData = {
  user: { password: "", email: "" },
  authenticated: false,
  handleLogin: () => {},
  decryptToken: () => {},
  handleLogout: () => {},
  loadingButton: false,
  objUserTk: { unique_name: "", UserId: 0, UserName: "", Type: "Office", OfficeId: 0 },
  sendEmailResetPassword: () => {},
  resetPassword: () => {},
  decryptTokenPass: () => {},
  activeUser: () => {}
};

export interface AuthContextData {
  user: { password: string; email: string };
  authenticated: boolean;
  handleLogin: (user: UserProps) => void;
  decryptToken: (token: string) => any;
  handleLogout: () => void;
  loadingButton: boolean;
  objUserTk: UserToken;
  sendEmailResetPassword: (email: string) => void;
  resetPassword: (userId: string, password: string) => void;
  decryptTokenPass: (token: string) => any;
  activeUser: (userId: string) => void;
}

export const AuthContext = createContext<AuthContextData>(initialState);

export default function AuthContextProvider({ children }: AuthContextProviderProps) {
  const {
    data,
    authenticated,
    loadingButton,
    handleLogin,
    handleLogout,
    objUserTk,
    decryptToken,
    sendEmailResetPassword,
    resetPassword,
    decryptTokenPass,
    activeUser
  } = useAuth();

  return (
    <AuthContext.Provider
      value={{
        user: data,
        authenticated,
        handleLogin,
        handleLogout,
        loadingButton,
        objUserTk: objUserTk,
        decryptToken,
        sendEmailResetPassword,
        resetPassword,
        decryptTokenPass,
        activeUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
